import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thick-down",
  "use": "icon-si-glyph-arrow-thick-down-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thick-down\" id=\"icon-si-glyph-arrow-thick-down\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1212</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.327,15.886 L13.774,9.946 C13.984,9.712 13.982,9.332 13.772,9.097 L9.931,9.092 L9.931,1.068 C9.931,0.515 9.494,0.068 8.955,0.068 L7.004,0.068 C6.464,0.068 6.028,0.515 6.028,1.068 L6.028,9.088 L2.078,9.083 C1.87,9.314 1.872,9.695 2.082,9.931 L7.567,15.885 C7.78,16.117 8.118,16.119 8.327,15.886 L8.327,15.886 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thick-down.svg
// module id = dZ/a
// module chunks = 62